var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileUploaderSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file (5) 1",
    clipPath: "url(#clip0_105_9964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.8152 0.833344H5.07084C3.75508 0.833344 2.66667 1.91616 2.66667 3.23191V19.7681C2.66667 21.0839 3.75508 22.1667 5.07084 22.1667H16.9395C18.2552 22.1667 19.3434 21.0839 19.3434 19.7681V6.6323L13.8152 0.833344Z",
    fill: "#438BFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.8423 0.849609L19.349 6.63763H15.6832C14.6654 6.63763 13.8423 5.81471 13.8423 4.79688V0.849609Z",
    fill: "#3F66D7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.4612 17.8892H6.54883C6.25117 17.8892 6.00755 18.1328 6.00755 18.4306C6.00755 18.7285 6.25117 18.9722 6.54883 18.9722H15.4667C15.7645 18.9722 16.0081 18.7285 16.0081 18.4306C16.0081 18.1328 15.7645 17.8892 15.4612 17.8892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.23294 12.0632L10.4637 9.66461V15.5771C10.4637 15.875 10.7073 16.1186 11.0051 16.1186C11.3029 16.1186 11.5466 15.875 11.5466 15.5771V9.66435L13.7773 12.0632C13.8855 12.1767 14.0263 12.2364 14.1725 12.2364C14.3026 12.2364 14.4378 12.1877 14.5409 12.0901C14.7573 11.8844 14.7736 11.5433 14.5678 11.3267L11.4004 7.92086C11.2975 7.81265 11.1568 7.74768 11.0052 7.74768C10.8535 7.74768 10.7128 7.81265 10.6099 7.92086L7.44245 11.3267C7.23672 11.5433 7.253 11.8899 7.4694 12.0901C7.68607 12.2959 8.02709 12.2796 8.23294 12.0632Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_9964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3333,
    height: 21.3333,
    fill: "white",
    transform: "translate(0.333336 0.833344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploaderSvg);
export default __webpack_public_path__ + "static/media/FileUploaderSvg.0359c1a2d01ef82ab4f190e2dcba5197.svg";
export { ForwardRef as ReactComponent };